module.exports = __webpack_public_path__ + "img/DTYLX_es.f6613e4d.png";